import React, {useState} from "react";
import style from "./block.module.scss";
import {AdherentModal} from "../modal/Modal"
import {ReactComponent as Arrow} from "../assets/arrow.svg";
import apiFetch from '@wordpress/api-fetch';

export default function PswdRecoveryForm({open, setVisibility}) {
    const [email, setEmail] = useState("");
    const [alert, setAlert] = useState();
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleChange = event => {
        setEmail(event.target.value);
    };

    const sendRecoveryMail = () => {
        setAlert();

        const emailRegex = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        if(!email || !emailRegex.test(email)) {
            return setAlert({type: 'error', message: "L'email saisi est incorrect"});
        }

        setLoading(true);

        try {
            apiFetch( {
                path: "/adherent/v1/resetPassword",
                method: 'POST',
                data: {
                    email
                }
                })
                .then(data => {
                    setAlert({type: 'success', message: "Un mail de récupération a été envoyé."});
                    setLoading(false);
                    setSuccess(true);
                })
                .catch(err => {
                    setAlert({type: 'error', message: "L'email saisi n'existe pas."});
                    setLoading(false);
                });
        } catch (e) {
            setAlert({type: 'error', message: "Une erreur est survenue"});
            setLoading(false);
        }
        
    };

    return (
        <AdherentModal open={open} setVisibility={setVisibility}>
                {!success && <div className={style.textBloc}>
                    <h2 className={style.title}>Vous avez oublié votre mot de passe</h2>
                    <hr className={style.separator}/>
                    <p className={style.condition}>Pour récupérer, merci de bien vouloir renseigner votre adresse email.</p>
                    
                    <div className={style.formContainer}>
                        <input onChange={handleChange} type="text" name="email" placeholder="Email" />
                        {alert && <p className={[style.alert, style[alert.type]].join(" ")} >{alert.message}</p>}
                    </div>

                    <div className={style.loginButtonContainer}>
                        <Arrow className={style.loginIcon}/>
                        <button disabled={loading} className={style.loginButton} onClick={sendRecoveryMail}>Générer un nouveau mot de passe</button>
                    </div>
                </div>}

                {success && <div className={style.textBloc}>
                    <h2 className={style.title}>Confirmation</h2>
                    <hr className={style.separator}/>
                    <p className={style.condition}>Votre demande de création d’un nouveau mot de passe a bien été envoyé. <br/>Vous allez recevoir un email pour créer votre nouveau mot de passe.</p>
                </div>}
        </AdherentModal>
    )
}